import { render } from "./check-icon.svg?vue&type=template&id=fc5415ec"
import script from "./check-icon.svg?vue&type=script&lang=js"
export * from "./check-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3609/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__